const truncate = (text, limit = 25) => {
  if (text?.length > limit) return `${text?.substring(0, limit)}...`;

  return text;
};

export default truncate;
